import { _ as t } from "./atoms-v21297.js";
import { _ as r } from "./atoms-v21298.js";
var o = t, s = r, a = s(o), S = a;
export {
  S as _
};
